import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lightbox"
export default class extends Controller {
  static targets = ["modal", "image", "currentImage", "totalImages"]

  connect() {
    console.log("🔥 Lightbox controller connected!")
    this.currentIndex = 0
    this.imageUrls = []
    
    // Collect image URLs from the gallery
    const galleryImages = this.element.querySelectorAll('[data-action*="lightbox#open"] img')
    galleryImages.forEach(img => {
      this.imageUrls.push(img.src)
    })
    
    console.log("Found images:", this.imageUrls.length)
    
    if (this.hasTotalImagesTarget) {
      this.totalImagesTarget.textContent = this.imageUrls.length
    }
  }

  open(event) {
    console.log("🚀 Opening lightbox")
    const index = parseInt(event.currentTarget.dataset.index)
    this.currentIndex = index
    this.showImage()
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = "auto"
  }

  previous() {
    this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.imageUrls.length - 1
    this.showImage()
  }

  next() {
    this.currentIndex = this.currentIndex < this.imageUrls.length - 1 ? this.currentIndex + 1 : 0
    this.showImage()
  }

  showImage() {
    if (this.imageUrls[this.currentIndex]) {
      this.imageTarget.src = this.imageUrls[this.currentIndex]
      this.currentImageTarget.textContent = this.currentIndex + 1
    }
  }

  closeOnBackground(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (this.modalTarget.classList.contains("hidden")) return

    switch(event.key) {
      case "Escape":
        this.close()
        break
      case "ArrowLeft":
        this.previous()
        break
      case "ArrowRight":
        this.next()
        break
    }
  }

  disconnect() {
    document.body.style.overflow = "auto"
  }
}